import a from './airdrop.png.js';
import b from './daily_rakeback.png.js';
import c from './deposit.png.js';
import d from './instant_rakeback.png.js';
import e from './month_reload.png.js';
import f from './vip_reload.png.js';
import g from './week_reload.png.js';
import x from './level_up_vip.png.js';

const airdrop = a;
const daily_rakeback = b;
const deposit = c;
const instant_rakeback = d;
const month_reload = e;
const vip_reload = f;
const week_reload = g;
const level_up_reward = x;

export { airdrop, daily_rakeback, deposit, instant_rakeback, level_up_reward, month_reload, vip_reload, week_reload };
//# sourceMappingURL=index.js.map
